import { render, staticRenderFns } from "./UserPolicies.vue?vue&type=template&id=ebfcc770&scoped=true"
import script from "./UserPolicies.vue?vue&type=script&lang=js"
export * from "./UserPolicies.vue?vue&type=script&lang=js"
import style0 from "./UserPolicies.vue?vue&type=style&index=0&id=ebfcc770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfcc770",
  null
  
)

export default component.exports